import { render, staticRenderFns } from "./Apis.vue?vue&type=template&id=498c16d2&scoped=true"
import script from "./Apis.vue?vue&type=script&lang=js"
export * from "./Apis.vue?vue&type=script&lang=js"
import style0 from "./Apis.vue?vue&type=style&index=0&id=498c16d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c16d2",
  null
  
)

export default component.exports